/**
 * Morph Text - cinematic title reveal.
 * Letters coalesce from runes with golden sparks, then gently undulate.
 */

const RUNES = '✦✧⟡◈◆⊛⊕⊗☽☾⍟✡⎈⏣⏥◬△▽⬡⬢⬣⊹✺✻';

export function initMorphText(root: HTMLElement): () => void {

  const elements = root.querySelectorAll<HTMLElement>('[data-morph]');
  const cleanups: (() => void)[] = [];

  for (const el of elements) {
    const original = el.textContent ?? '';
    const duration = Number(el.dataset.morphDuration ?? 2000);
    const delay = Number(el.dataset.morphDelay ?? 0);

    el.textContent = '';
    el.style.visibility = 'visible';
    el.classList.add('morph-container');

    const chars: HTMLSpanElement[] = [];
    for (let i = 0; i < original.length; i++) {
      const span = document.createElement('span');
      span.className = 'morph-char';
      span.textContent = '';
      span.style.setProperty('--i', String(i));
      el.appendChild(span);
      chars.push(span);
    }

    const timePerChar = duration / original.length;
    const timeouts: ReturnType<typeof setTimeout>[] = [];

    const startTimeout = setTimeout(() => {
      for (let i = 0; i < original.length; i++) {
        const charTimeout = setTimeout(() => {
          const span = chars[i];
          const ch = original[i];
          if (!span || ch === undefined) return;
          if (ch === ' ') {
            span.textContent = ' ';
            span.classList.add('morph-revealed');
            return;
          }

          span.classList.add('morph-arriving');
          span.textContent = RUNES[Math.floor(Math.random() * RUNES.length)] ?? '✦';

          const flickerCount = 5 + Math.floor(Math.random() * 5);
          let flicker = 0;
          const flickerInterval = setInterval(() => {
            flicker++;
            if (flicker >= flickerCount) {
              clearInterval(flickerInterval);
              span.textContent = original[i] ?? '';
              span.classList.remove('morph-arriving');
              span.classList.add('morph-revealed');
            } else {
              span.textContent = RUNES[Math.floor(Math.random() * RUNES.length)] ?? '✦';
            }
          }, 60);
          timeouts.push(flickerInterval as unknown as ReturnType<typeof setTimeout>);
        }, i * timePerChar);
        timeouts.push(charTimeout);
      }

      const waveTimeout = setTimeout(() => {
        el.textContent = original;
        el.classList.remove('morph-container');
        el.classList.add('morph-complete');
      }, duration + 500);
      timeouts.push(waveTimeout);
    }, delay);
    timeouts.push(startTimeout);

    cleanups.push(() => {
      for (const t of timeouts) clearTimeout(t);
      el.textContent = original;
      el.classList.remove('morph-container', 'morph-complete');
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
